<template lang="pug">
.stars
  LucideIcon(
    v-for="index in total"
    :key="index"
    name="Star"
    :size="size"
    :fill="getFill(index)"
    :stroke="getStroke(index)"
  )
</template>

<script>
export default{
  name: 'Estrelas',
  props: {
    filled: {
      type: Number,
      required: true,
    },
    total: {
      type: Number,
      default: 5,
    },
    filledColor: {
      type: String,
      default: '#facc15',
    },
    emptyColor: {
      type: String,
      default: '#3f3f46',
    },
    size: {
      type: [String, Number],
      default: 24,
    },
    useStroke: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    getStroke(index){
      if(index <= this.filled && this.useStroke) return this.filledColor
      if(index <= this.filled && !this.useStroke) return this.filledColor
      else return this.emptyColor
    },
    getFill(index){
      if(index <= this.filled && this.useStroke) return this.filledColor
      else return 'none'
    }
  }
}
</script>

<style scoped lang="scss">
.stars {
  display: flex;
  align-items: center;
  gap: 1px;
}
</style>